<template>
    <Toast />
    <div class="card">
        <DataTable
            :value="tableData"
            showGridlines
            stripedRows
            :rows="rows"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            :paginator="true"
            :loading="loading"
            @page="onPaginate"
            :rowsPerPageOptions="[10, 25, 100]"
            tableStyle="min-width: 50rem"
            lazy
        >
        <template #header>
            <div class="search-container">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText
                          v-model="criteria"
                          placeholder="Rechercher par Email"
                          @keyup.enter="onFilterDt"
                          @input="onClearInputFilter"
                      />
                    </span>
            </div>
        </template>
        <Column field="user.email" header="Mail whitelistée"></Column>
        <Column field="description" header="Description"></Column>
        <Column field="requestedBy" header="Demandé par"></Column>
        <Column field="createdAt" header="Date d'ajout">
            <template #body="slotProps">
                {{ formatDate(slotProps.data.createdAt) }}
            </template>
        </Column>
        <Column header="Ajouté par">
            <template #body="slotProps">
                {{ slotProps.data.createdBy.firstname }} {{ slotProps.data.createdBy.lastname }}
            </template>
        </Column>        
        <Column field="status" header="Statut">
            <template #body="slotProps">
                <Tag :value="slotProps.data.status ? 'Actif' : 'Inactif'" :severity="slotProps.data.status ? 'success' : 'danger'" rounded />
            </template>
        </Column>
        <Column>
            <template #header>
                <div>Actions</div>
            </template>
            <template #body="slotProps">
                <InputSwitch v-model="slotProps.data.status" @change="() => handleStatusChange(slotProps.data)" />
                <Button @click="() => confirmDeleteDialog(slotProps.data)" type="button" title="Supprimer" icon="pi pi-trash" class="ml-1 p-button-danger"></Button>
            </template>
        </Column>
        <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { deleteEmail, fetchUserWhitelists, toggleStatus } from '@/_services/securite/whitelist/EmailWhitelist';
import { UserWhiteList } from '@/models/securite/whitelist/EmailWhitelist';
import { useConfirm } from 'primevue/useconfirm';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputSwitch from "primevue/inputswitch";

const tableData = ref<UserWhiteList[]>([]);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const loading = ref<boolean>(true);
const page = ref<number>(1);
const criteria = ref<string>("");
const toast = useToast();
const confirm = useConfirm();


onMounted(async () => {
    await populateDatatable();
});

async function populateDatatable() {
    loading.value = true
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchUserWhitelists(rows.value, page.value, criteria.value.trim());
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;
    return [loading.value, totalRecords.value, tableData.value]

}
const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
const onFilterDt = async () => {
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const handleStatusChange = async (data: UserWhiteList) => {
    try {
        await toggleStatus(data);
        toast.add({ severity: 'success', summary: 'Success', detail: 'Le statut a bien été modifié !', life: 3000 });
        await populateDatatable();
    } catch (error) {
        let errorMessage = 'Erreur inconnue.';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
    }
};
const confirmDeleteDialog = (user: UserWhiteList) => {
    confirm.require({
        group: 'global',
        message: 'Êtes-vous sûr de vouloir supprimer cette email ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'p-button-danger',
        defaultFocus: "reject",
        accept: async () => {
            try {
                await deleteEmail(user.uuid);
                toast.add({ severity: 'success', summary: 'Supprimé', detail: `L'adresse mail a bien été supprimée.`, life: 3000 });
                await populateDatatable();
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur de suppression', detail: `Échec de la suppression de l'email`, life: 3000 });
            }
        },
    });
};


/*const confirmStatusChangeDialog = (data) => {
    confirm.require({
        group: 'global-status',
        message: `Êtes-vous sûr de vouloir changer le statut de cet élément ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        accept: async () => {
            try {
                await toggleStatus(data);
                toast.add({ severity: 'success', summary: 'Succès', detail: `Le statut a bien été modifié`, life: 3000 });
                await populateDatatable();
            } catch (error) {
                let errorMessage = 'Erreur inconnue.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                toast.add({ severity: 'error', summary: 'Erreur', detail: errorMessage, life: 3000 });
            }
        }
    });
};*/
</script>
<style scoped>
.p-dialog .p-dialog-footer button {
    color: red !important;
    background-color: #41c5b7;
}
</style>